<template>
  <PlanLearnMoreDialog
    v-if="learnMoreConfig.modalType === addonLearnMoreType.PLAN"
    :visible="visible"
    :plan-type="learnMoreConfig.planType"
    :plan-config="{
      _hideBtns: false,
      buy_cta: $t('billing.common.add'),
      hideOptions: hideOptions
    }"
    @close="handleClose"
    @click="handleAddAction__plan"
    @change="handleChangeAction__plan"
  />
  <AddonLearnMoreDialog
    v-else-if="learnMoreConfig.modalType === addonLearnMoreType.ADDON"
    :visible="visible"
    :plan-type="learnMoreConfig.planType"
    :btn-label="$t('billing.common.add')"
    :price-info="priceInfo"
    :hide-options="hideOptions"
    @dialogClose="handleClose"
    @addPlan="handleAddAction__addon"
    @planTypeChange="handleChangeAction__addon"
  />
</template>

<script>
import {PLAN_LEARN_MORE_DIALOG as PlanLearnMoreDialog, ADDON_LEARN_MORE_DIALOG as AddonLearnMoreDialog} from '@zoom/billing-shared'
import {addonLearnMoreType} from "@/common/constants";
import {mapMutations} from "vuex";

export default {
  name: 'LearnMoreDialog',
  components: {PlanLearnMoreDialog, AddonLearnMoreDialog},
  props: {
    learnMoreConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      categoryCode: null
    }
  },
  computed: {
    addonLearnMoreType() {
      return addonLearnMoreType;
    },
    visible() {
      return this.learnMoreConfig.visible && this.learnMoreConfig.modalType;
    },
    priceInfo() {
      const productPlans = this.learnMoreConfig.productPlans;
      if (!productPlans?.length) {
        return [];
      }
      let monthPrice;
      let yearPrice;
      if (this.categoryCode) {
        monthPrice = productPlans.find(plan => plan.category === this.categoryCode && plan.billing_cycle === 'monthly')?.amount;
        yearPrice = productPlans.find(plan => plan.category === this.categoryCode && plan.billing_cycle === 'annual')?.amount;
      }
      if (!monthPrice && !yearPrice) {
        monthPrice = productPlans.find(plan => plan.billing_cycle === 'monthly')?.amount;
        yearPrice = productPlans.find(plan => plan.billing_cycle === 'annual')?.amount;
      }
      return {_month: monthPrice, _year: yearPrice};
    },
    hideOptions() {
      return this.learnMoreConfig.hideOptions || !this.learnMoreConfig.productPlans || this.learnMoreConfig.productPlans.length < 2;
    }
  },
  methods: {
    ...mapMutations(['setLearnMoreConfig']),
    handleClose() {
      this.setLearnMoreConfig({...this.learnMoreConfig, visible: false});
      this.$tracking.addOnBuyInteraction(`${this.learnMoreConfig.trackingBasePlanName} add-ons`, `add-ons - ${this.learnMoreConfig.trackingPlanTitle?.toLowerCase()} - learn more modal - close`);
    },
    handleAddAction__plan(evt, type, configs) {
      this.setLearnMoreConfig({...this.learnMoreConfig, categoryCode: configs?.planType});
      this.learnMoreConfig.addAction?.();
      this.setLearnMoreConfig({...this.learnMoreConfig, visible: false, categoryCode: null});
    },
    handleChangeAction__plan(configs) {
      this.categoryCode = configs?.planType;
      this.setLearnMoreConfig({...this.learnMoreConfig, categoryCode: configs?.planType});
    },
    handleAddAction__addon(selectedPlan) {
      this.setLearnMoreConfig({...this.learnMoreConfig, categoryCode: selectedPlan?.currentPlan});
      this.learnMoreConfig.addAction?.();
      this.setLearnMoreConfig({...this.learnMoreConfig, visible: false, categoryCode: null});
    },
    handleChangeAction__addon(config) {
      this.categoryCode = config?.currentPlan;
      this.setLearnMoreConfig({...this.learnMoreConfig, categoryCode: config?.currentPlan});
    }
  },
  watch: {
    'learnMoreConfig.visible': {
      handler: function (newVal, oldVal) {
        if (newVal && !oldVal) {
          // track impression of learn more modal being shown
          this.$tracking.addOnBuyInteraction(`${this.learnMoreConfig.trackingBasePlanName} add-ons`, `add-ons - ${this.learnMoreConfig.trackingPlanTitle?.toLowerCase()} - learn more modal - impression`);
        }
      }
    },
    'learnMoreConfig.planType': {
      handler: function() {
        this.categoryCode = null;
      }
    }
  }
}
</script>

